import { EVatType as EVatTypeRepositories } from '../repositories/monolith-python/entities/offer/BargainTermsSchema';

export enum EVatType {
  /** НДС включен **/
  Included = EVatTypeRepositories.Included,
  /** НДС не включен **/
  NotIncluded = EVatTypeRepositories.NotIncluded,
  /** УСН (упрощенная система налогообложения) **/
  Usn = EVatTypeRepositories.Usn,
}
